"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTldListFromDotTypesText = void 0;
/**
 * @function getTldListFromDotTypesText
 * @description Given a string of comma separated domains, and a main domain, this
 * function returns an array of top level domains (TLDs) that can be used to get
 * a list of TLDs for a given domain.
 *
 * @param {Object} options - An object containing the properties below
 * @param {String} options.DotTypesText - A comma separated string of domains
 * @param {String} options.mainDomain - The main domain to search for
 *
 * @returns {Array<String>} An array of TLDs
 */
const getTldListFromDotTypesText = ({
  DotTypesText,
  mainDomain
}) => {
  const listOfDomains = DotTypesText?.split(',');
  return listOfDomains?.map(domain => domain.replace(mainDomain, ''));
};
exports.getTldListFromDotTypesText = getTldListFromDotTypesText;